import React from "react";
import styles from "./Gallery.module.css";
import { ShoppingCart } from "../ShoppingCart/ShoppingCart";
import { ShopForm } from "../ShoppingCart/ShopForm/ShopForm";
import { Icons } from "../Icons/Icons";
import { PiHandHeartFill } from "react-icons/pi";
import { MiniFaq } from "../MiniFaq/MiniFaq";
import {
  BsFillBalloonHeartFill,
  BsFillBagHeartFill,
  BsFillQuestionCircleFill,
} from "react-icons/bs";
import { SectionGallery } from "../SectionGallery/SectionGallery";

function Gallery({
  setShowGallery,
  setShowGalleryAmigurumis,
  setShowGalleryAnime,
  setShowGalleryChenille,
  setShowGalleryKeychain,
  setShowGalleryRandom,
}) {
  const [showFaq, setShowFaq] = React.useState(false);
  const [showShoppingCart, setShowShoppingCart] = React.useState(false);

  function shopping() {
    showShoppingCart === false
      ? setShowShoppingCart(true)
      : setShowShoppingCart(false);
  }

  return (
    <div className={styles.container}>
      <ShoppingCart shopping={shopping}></ShoppingCart>
      {showShoppingCart && (
        <ShopForm setShowShoppingCart={setShowShoppingCart}></ShopForm>
      )}

      <h2 className={styles.title}>
        Galería{" "}
        <BsFillQuestionCircleFill
          className={styles.question}
          onMouseMove={() => setShowFaq(true)}
          onMouseLeave={() => setShowFaq(false)}
        ></BsFillQuestionCircleFill>
        {showFaq && <MiniFaq></MiniFaq>}
      </h2>
      <h3 className={styles.subtitle}>
        Un amigurumi es más que un muñeco, es un compañero especial y único
      </h3>

      <SectionGallery
        setShowGallery={setShowGallery}
        setShowGalleryAmigurumis={setShowGalleryAmigurumis}
        setShowGalleryAnime={setShowGalleryAnime}
        setShowGalleryChenille={setShowGalleryChenille}
        setShowGalleryKeychain={setShowGalleryKeychain}
        setShowGalleryRandom={setShowGalleryRandom}
      ></SectionGallery>

      <div className={styles.footer}>
        <Icons
          flex={{ flexDirection: "column", whiteSpace: "wrap" }}
          text="Hecho a mano"
          icon={<PiHandHeartFill></PiHandHeartFill>}
          style={{ fontSize: "5rem" }}
        ></Icons>
        <Icons
          flex={{ flexDirection: "column", whiteSpace: "wrap" }}
          text="Con amor"
          icon={<BsFillBalloonHeartFill></BsFillBalloonHeartFill>}
          style={{ fontSize: "5rem" }}
        ></Icons>
        <Icons
          flex={{ flexDirection: "column", whiteSpace: "wrap" }}
          text="Y cuidado en cada detalle"
          icon={<BsFillBagHeartFill></BsFillBagHeartFill>}
          style={{ fontSize: "5rem" }}
        ></Icons>
      </div>
    </div>
  );
}

export { Gallery };
